import clsx from 'clsx'
import React, { useContext, useEffect, useRef } from 'react'

import { MetadataContext } from '@Globals/Metadata'

const useTrustPilotScript = (shouldRender: boolean) => {
  useEffect(() => {
    if (!shouldRender) {
      return
    }

    const tpScriptID = 'th-trustpilot-v5'
    const hasScriptLoaded = !!document.getElementById(tpScriptID)

    if (hasScriptLoaded) {
      return
    }

    const tpScript = document.createElement('script')
    tpScript.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
    tpScript.id = tpScriptID
    tpScript.async = true

    document.body.appendChild(tpScript)
  }, [shouldRender])
}

interface TrustPilotWidgetProps {
  className?: string
}

export const TrustPilotWidget = ({ className }: TrustPilotWidgetProps) => {
  const { store } = useContext(MetadataContext)
  const ref = useRef(null)

  const trustPilotBusinessID = store?.config?.trustpilotBusinessID
  const trustPilotDomain = store?.config?.trustpilotDomain
  const localeCode = store?.config?.localeCode
  const storeHost = store?.config?.urlDomain

  const shouldRender = !!(trustPilotBusinessID && trustPilotDomain)

  useTrustPilotScript(shouldRender)

  useEffect(() => {
    (window as any).Trustpilot?.loadfromElement?.(ref.current, true)
  }, [])

  if (!shouldRender) {
    return <div />
  }

  return (
    <div
      className={clsx(className, {
        'trustpilot-widget': true,
      })}
      data-businessunit-id={trustPilotBusinessID}
      data-locale={localeCode}
      data-stars="4,5"
      data-style-height="140px"
      data-style-width="100%"
      data-template-id="53aa8912dec7e10d38f59f36"
      data-theme="light"
      ref={ref}
    >
      <a href={`https://${trustPilotDomain}/review/${storeHost}`} rel="noreferrer" target="_blank">
        Trustpilot
      </a>
    </div>
  )
}
